import { TMetricLevel } from '../../../cabinet/components/CabinetPreferences/interfaces';
import { IRequestMetricsArgs, TTimeFreq } from '../../../lib/esm/components';
import { IPeriod } from '../../../General.interfaces';

interface IArgs {
    selectedReportingObjectsIds: number[];
    timiFreq: TTimeFreq | null;
    metricLevel: TMetricLevel;
    dateRanges: IPeriod[];
    selectedMetrics: string[];
    period: IPeriod;
    token: string;
    alias?: string;
}

/**
 * Функция для получения данных, необходимых для запроса метрик
 * @param selectedReportingObjectsIds Массив ID выбранных отчетных объектов
 * @param selectedMetrics Массивы выбранных метрик
 * @param dateRanges Массив временных интервалов для выбранного основоного периода
 * @param metricLevel Уровень мметрик
 * @param period Выбранный период
 * @param timiFreq Детализация данных
 * @param token Токен авторизации
 * @returns Массив данных, необходимых для запроса выбранных метрик
 */
const generateMetricsQueryData = (args: IArgs): IRequestMetricsArgs[] => {
    const {
        selectedReportingObjectsIds,
        dateRanges,
        period,
        selectedMetrics,
        metricLevel,
        token,
        timiFreq,
        alias = null,
    } = args;
    const queryData: IRequestMetricsArgs[] = [];

    const mainPeriodDateRnage = dateRanges?.find((element) => element.id === period.id);

    if (mainPeriodDateRnage?.period) {
        selectedMetrics.forEach((metric) => {
            queryData.push({
                time_range: [mainPeriodDateRnage.period!.dateFrom, mainPeriodDateRnage.period!.dateTo],
                obj_ids: selectedReportingObjectsIds,
                metric_level: metricLevel,
                object_aggregation: false,
                time_freq: timiFreq,
                alias: alias,
                metric,
                token,
            });
        });
    }

    return queryData;
};

export default generateMetricsQueryData;
